/* The pose/size pills of "Generic variants" products (snippet
 * custom-pose-size-picker, rendered in the hero copy column and again above
 * the stock line on phones). A pill checks its radio in custom-product's
 * hidden <variant-radios> and fires change, so custom-variant-radios.js
 * switches the variant; this script then re-marks every picker instance and
 * swaps the parts the partial render leaves stale (the buy column, for the
 * quote-only state, and the maker's product number in the copy).
 */
(() => {
  if (window.ltsPoseSizePicker) return;
  window.ltsPoseSizePicker = true;

  /* Only the newest hero fetch may swap the gallery. */
  let galleryFetchToken = null;

  function radiosEl() {
    return document.querySelector('variant-radios');
  }

  function variantData() {
    const el = radiosEl() && radiosEl().querySelector('script[type="application/json"]');
    return el ? JSON.parse(el.textContent) : [];
  }

  function selected() {
    const picked = {};
    document.querySelectorAll('variant-radios input[type="radio"]:checked').forEach((radio) => {
      picked[radio.name] = radio.value;
    });
    return picked;
  }

  /* Pose first, size second — the import creates the options in that order. */
  function findVariant(pose, size) {
    return variantData().find((v) => v.option1 === pose && v.option2 === size);
  }

  function refreshPills() {
    const picked = selected();
    document.querySelectorAll('[data-pose-size-picker] .pose-size-picker__pill').forEach((pill) => {
      const on = picked[pill.dataset.optionName] === pill.dataset.optionValue;
      pill.classList.toggle('is-selected', on);
      pill.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (pill.dataset.optionName === 'Size') {
        const exists = !!findVariant(picked['Pose'], pill.dataset.optionValue);
        pill.classList.toggle('is-disabled', !exists);
        if (exists) pill.removeAttribute('aria-disabled');
        else pill.setAttribute('aria-disabled', 'true');
      }
    });
  }

  function check(name, value) {
    const radio = Array.from(document.querySelectorAll('variant-radios input[type="radio"]')).find(
      (input) => input.name === name && input.value === value
    );
    if (radio) radio.checked = true;
    return radio;
  }

  function setVariant(pose, size) {
    check('Pose', pose);
    const radio = check('Size', size);
    refreshPills();
    if (radio) radio.dispatchEvent(new Event('change', { bubbles: true }));
  }

  document.addEventListener('click', (event) => {
    const pill = event.target.closest('[data-pose-size-picker] .pose-size-picker__pill');
    if (!pill || pill.classList.contains('is-disabled')) return;

    const picked = selected();
    let pose = picked['Pose'];
    let size = picked['Size'];

    if (pill.dataset.optionName === 'Pose') {
      pose = pill.dataset.optionValue;
      if (!findVariant(pose, size)) {
        /* The pose is not made in the current size: fall back to its first size. */
        const fallback = variantData().find((v) => v.option1 === pose);
        if (!fallback) return;
        size = fallback.option2;
      }
    } else {
      size = pill.dataset.optionValue;
    }

    if (pose === picked['Pose'] && size === picked['Size']) return;
    setVariant(pose, size);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      if (!document.querySelector('[data-pose-size-picker]')) return;
      refreshPills();

      /* custom-variant-radios.js only swaps price, sku, stock line and the
       * buy button's disabled state. The quote-only state (the quote-request
       * opener replaces the form, carrying the selected variant) lives in the
       * buy column, so that column is swapped wholesale from the same render. */
      const html = event.data && event.data.html;
      if (html) {
        const destination = document.querySelector('.mainproduct__content__right');
        const source = html.querySelector('.mainproduct__content__right');
        if (destination && source) destination.innerHTML = source.innerHTML;
      }

      /* The maker's product number in the copy column (its section is not
       * re-rendered). The number is the SKU after the brand prefix. */
      const variant = event.data && event.data.variant;
      if (variant && variant.sku && variant.sku.indexOf('-') !== -1) {
        const code = variant.sku.split('-').slice(1).join('-');
        document.querySelectorAll('[data-vendor-sku-code]').forEach((line) => {
          const old = line.dataset.vendorSkuCode;
          if (old && old !== code) {
            line.textContent = line.textContent.replace(old, code);
            line.dataset.vendorSkuCode = code;
          }
        });
      }

      /* Variant-filtered gallery: a variant change re-renders the hero
       * section (the carousel shows only the selected variant's own photos,
       * Liquid-side — the maker photographs every number, so pose AND size
       * match what is selected). The swap goes through
       * createContextualFragment so the hero's inline scripts run again;
       * the zoom popup lives outside the swapped div and keeps every photo,
       * so the new slides' openers still resolve. */
      const gallery = document.querySelector('[data-pose-gallery]');
      if (gallery && variant && variant.sku) {
        if (variant.sku !== gallery.dataset.sku) {
          const token = (galleryFetchToken = {});
          fetch(`${gallery.dataset.url}?variant=${variant.id}&section_id=${gallery.dataset.sectionId}`)
            .then((response) => response.text())
            .then((text) => {
              if (token !== galleryFetchToken) return;
              const doc = new DOMParser().parseFromString(text, 'text/html');
              const source = doc.querySelector('[data-pose-gallery]');
              if (!source || !document.querySelector('[data-pose-gallery]')) return;

              /* The render puts the selected variant's photos first, so the
               * fresh carousel already opens on the right photo. The swap is
               * a quick dissolve: once the incoming first photo has decoded
               * (instant when its preload has landed), the old gallery fades
               * out, the fragment goes in hidden, and fades back in. The race
               * keeps a photoless or lazy slide from stalling the swap. */
              const fragment = document.createRange().createContextualFragment(source.outerHTML);
              const incoming = fragment.querySelector('[data-pose-gallery]');
              const firstImage = incoming && incoming.querySelector('img');
              const decoded =
                firstImage && firstImage.decode ? firstImage.decode().catch(() => {}) : Promise.resolve();
              Promise.race([decoded, new Promise((done) => setTimeout(done, 250))]).then(() => {
                if (token !== galleryFetchToken) return;
                const target = document.querySelector('[data-pose-gallery]');
                if (!target) return;
                target.classList.add('pose-gallery--dissolve');
                setTimeout(() => {
                  if (token !== galleryFetchToken) return;
                  const stale = document.querySelector('[data-pose-gallery]');
                  if (!stale) return;
                  if (incoming) incoming.classList.add('pose-gallery--dissolve');
                  stale.replaceWith(fragment);
                  requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                      const fresh = document.querySelector('[data-pose-gallery]');
                      if (fresh) fresh.classList.remove('pose-gallery--dissolve');
                    });
                  });
                }, 160);
              });
            });
        }
      }
    });
  }
})();
